import { render, staticRenderFns } from "./HotRank.vue?vue&type=template&id=2cd58695&scoped=true&"
import script from "./HotRank.vue?vue&type=script&lang=js&"
export * from "./HotRank.vue?vue&type=script&lang=js&"
import style0 from "./HotRank.vue?vue&type=style&index=0&id=2cd58695&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd58695",
  null
  
)

export default component.exports